export enum SupportedFileType {
    PDF = 'application/pdf',
    EXCEL = 'application/vnd.ms-excel',
    VIDEO_WEBM = 'video/webm'
}

export interface ConfirmationModalCheckableResponse {
    buttonAction: boolean,
    dontShowAgainCheckStatus: boolean
}

export interface GetCaseReportPDFParams {
    laboratoryId: number
    caseId: number
    caseLabel: string
    print: boolean
    hasAssociatedCases?: boolean
    isClinical?: boolean
}
